var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{attrs:{"src":_vm.thumbnailURL},on:{"error":_vm.setDefaultThumbnail,"load":function($event){return _vm.$emit('loaded')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }